<div class="w-full dashboard-grid my-4">
  <ng-container *ngFor="let component of components$ | async">
    <ng-container *ngComponentOutlet="component"> </ng-container>
  </ng-container>
</div>
